import get from 'lodash/get';
import { createReducer } from '@reduxjs/toolkit';

import { ADMIN_UPDATE_PAGE_TITLE } from 'constants/redux-actions';

const initState = {};

const adminPageReducer = createReducer(initState, {
  [ADMIN_UPDATE_PAGE_TITLE]: (prevState, action) => {
    const name = get(action, 'payload');

    return {
      ...prevState,
      name,
    };
  },
});

export default adminPageReducer;
